
import { defineComponent, PropType } from 'vue';
import { Column } from './types';

export default defineComponent({
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: true,
            type: Array as PropType<Array<Column<unknown, unknown>>>,
        },
    },
    methods: {
        toggleColumn(toggledColumn: Column<unknown, unknown>) {
            this.$emit('update:modelValue', [
                ...this.modelValue.map((col) => {
                    return new Column(
                        col.def,
                        toggledColumn.def.field === col.def.field
                            ? !col.visible
                            : col.visible
                    );
                }),
            ]);
        },
    },
});
